var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Model, validator, TransformValidateModel, } from "@musicaudienceexchange/toccata";
const AlignTypes = ["left", "right"];
const SocialColorNames = ["black", "white", "default"];
const PlacementTypes = [
    "behind-all",
    "behind-title-body",
    "behind-body-action",
    "behind-body",
];
const LayoutTypes = ["default", "side-by-side", "social", "merch"];
const ExpandTypes = ["small", "regular", "large", "full"];
export class ButtonProps extends Model {
}
__decorate([
    validator.IsString()
], ButtonProps.prototype, "text", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], ButtonProps.prototype, "color", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], ButtonProps.prototype, "fill", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], ButtonProps.prototype, "action", void 0);
export class BackgroundProps extends Model {
}
__decorate([
    validator.IsString()
], BackgroundProps.prototype, "src", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], BackgroundProps.prototype, "size", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsNumber()
], BackgroundProps.prototype, "opacity", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], BackgroundProps.prototype, "position", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsIn(PlacementTypes),
    validator.IsString()
], BackgroundProps.prototype, "placement", void 0);
export class ImageProps extends BackgroundProps {
}
__decorate([
    validator.IsOptional(),
    validator.IsNumber()
], ImageProps.prototype, "width", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsNumber()
], ImageProps.prototype, "height", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsIn(AlignTypes),
    validator.IsString()
], ImageProps.prototype, "align", void 0);
export class MerchStyles extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], MerchStyles.prototype, "fill", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], MerchStyles.prototype, "body", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsNumber()
], MerchStyles.prototype, "radius", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], MerchStyles.prototype, "buttonFill", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], MerchStyles.prototype, "buttonColor", void 0);
export class MerchBlock extends Model {
}
__decorate([
    validator.IsString()
], MerchBlock.prototype, "body", void 0);
__decorate([
    validator.IsString()
], MerchBlock.prototype, "image", void 0);
__decorate([
    TransformValidateModel(ButtonProps)
], MerchBlock.prototype, "button", void 0);
export class Merch extends Model {
}
Merch.defaults = {
    columns: 2,
    styles: {},
};
__decorate([
    validator.IsOptional(),
    TransformValidateModel(MerchStyles)
], Merch.prototype, "styles", void 0);
__decorate([
    TransformValidateModel(MerchBlock, { each: true })
], Merch.prototype, "blocks", void 0);
__decorate([
    validator.IsNumber()
], Merch.prototype, "columns", void 0);
export class SocialLinks extends Model {
}
__decorate([
    validator.IsString({ each: true })
], SocialLinks.prototype, "urls", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsIn(SocialColorNames),
    validator.IsString()
], SocialLinks.prototype, "color", void 0);
export class PageProperties extends Model {
}
PageProperties.defaults = {
    layout: "default",
    expand: "regular",
};
__decorate([
    validator.IsIn(LayoutTypes),
    validator.IsString()
], PageProperties.prototype, "layout", void 0);
__decorate([
    validator.IsIn(ExpandTypes),
    validator.IsString()
], PageProperties.prototype, "expand", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], PageProperties.prototype, "header", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], PageProperties.prototype, "footer", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(BackgroundProps)
], PageProperties.prototype, "background", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], PageProperties.prototype, "title", void 0);
__decorate([
    validator.ValidateIf((o) => ["side-by-side", "social"].includes(o.layout)),
    validator.IsOptional(),
    TransformValidateModel(ImageProps)
], PageProperties.prototype, "image", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], PageProperties.prototype, "body", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(ButtonProps)
], PageProperties.prototype, "button", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], PageProperties.prototype, "qrLink", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(SocialLinks)
], PageProperties.prototype, "social", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Merch)
], PageProperties.prototype, "merch", void 0);
export class PageViewProps extends Model {
}
__decorate([
    TransformValidateModel(PageProperties)
], PageViewProps.prototype, "beforeCheckIn", void 0);
__decorate([
    TransformValidateModel(PageProperties)
], PageViewProps.prototype, "afterCheckIn", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(PageProperties)
], PageViewProps.prototype, "winner", void 0);
//# sourceMappingURL=templates.js.map